import { useState, useEffect } from "react";
import { getSubjectMatterChoices } from "../features/Tdsat/API/TdsatApi";

const useSubjectMatterChoices = (caseType) => {
  const [subjectMatterChoices, setSubjectMatterChoices] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSubjectMatterChoices = async () => {
      try {
        const response = await getSubjectMatterChoices(caseType);
        setSubjectMatterChoices(response?.data);
      } catch (error) {
        console.error("Error fetching subject matter", error);
        setError(error);
      }
    };
    if(caseType)
      fetchSubjectMatterChoices();
  }, [caseType]);

  return { subjectMatterChoices, error };
};

export default useSubjectMatterChoices;